module.exports = __webpack_public_path__ + "img/floor-anchor.483457ab.png";